import type * as React from 'react';
import { post } from '@Domain/Api';
import aiCostLimitCreated, {
	type AiCostLimitCreatedAction,
} from '@Application/AiCostLimits/Limits/Actions/aiCostLimitCreated';
import aiCostLimitCreationFailed, {
	type AiCostLimitCreationFailedAction,
} from '@Application/AiCostLimits/Limits/Actions/aiCostLimitCreationFailed';
import type { AiCostLimitPayload } from '@Application/AiCostLimits/Limits/Actions/aiCostLimitsFetched';
import type CreateAiCostLimit from '@Application/AiCostLimits/Limits/Commands/CreateAiCostLimit';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = AiCostLimitCreatedAction | AiCostLimitCreationFailedAction;

export default (command: CreateAiCostLimit) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<AiCostLimitPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/ai-cost-limits`,
				command.toJSON(),
			);

			const action = aiCostLimitCreated(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiCostLimitCreationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
